import React from 'react';

interface ReadingTimeProps {
  wordCount: number;
}

const ReadingTime: React.FC<ReadingTimeProps> = ({ wordCount }) => {
  return (
    <div className="flex justify-center mb-[-30px]">
      <div className="flex items-center">
        <div className="w-6 h-6 mr-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <p className="text-sm">{Math.round(wordCount / 190)} min</p>
      </div>
    </div>
  );
};

export default ReadingTime;
